var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.ageChildren
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "page ageChildren-page",
            attrs: { id: "print_ageChildren" },
          },
          [
            _c("div", { staticStyle: { height: "15px" } }),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "15px",
                  "margin-bottom": "15px",
                  "line-height": "1.2",
                  "font-weight": "600",
                  "letter-spacing": "5px",
                  "font-size": "23px !important",
                },
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.model.ageChildren.reportName
                        ? _vm.model.ageChildren.reportName
                        : "3~6岁儿童健康检查记录表"
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticClass: "header",
                staticStyle: {
                  "padding-left": "10px",
                  "text-align": "left",
                  "font-size": "14px",
                  "border-collapse": "collapse",
                  width: "100%",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        height: "30px",
                        "font-size": "13px",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "15%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("姓名："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.ageChildren.name
                                  ? _vm.model.ageChildren.name
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "10%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("性别："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.ageChildren.sex
                                  ? _vm.model.ageChildren.sex
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "22%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("出生日期："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.ageChildren.birthday
                                  ? _vm.model.ageChildren.birthday
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "18%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("班级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.ageChildren.className
                                  ? _vm.model.ageChildren.className
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("幼儿园："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.ageChildren.schoolName
                                  ? _vm.model.ageChildren.schoolName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "text-align": "center",
                  "font-size": "12px",
                  "border-collapse": "collapse",
                  width: "100%",
                },
                attrs: { width: "700" },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "120px",
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                          attrs: { colspan: "2" },
                        },
                        [_vm._v("月（年）龄")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                              },
                            },
                            [_vm._v(_vm._s(item.monthAge))]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "120px",
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                          attrs: { colspan: "2" },
                        },
                        [_vm._v("随访日期")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  item.followUpDate ? item.followUpDate : ""
                                )
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                          attrs: { colspan: "2" },
                        },
                        [_vm._v("体重/kg")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                              },
                            },
                            [
                              _c("input", {
                                staticStyle: {
                                  width: "40px",
                                  "border-bottom": "1px solid black",
                                  "border-top": "none",
                                  "border-left": "none",
                                  "border-right": "none",
                                  "margin-bottom": "3px",
                                },
                                domProps: {
                                  value: item.weight ? item.weight : "",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.weightAssessment &&
                                      item.weightAssessment.indexOf("上") > -1,
                                  },
                                },
                                [_vm._v("上  ")]
                              ),
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.weightAssessment &&
                                      item.weightAssessment.indexOf("中") > -1,
                                  },
                                },
                                [_vm._v("中  ")]
                              ),
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.weightAssessment &&
                                      item.weightAssessment.indexOf("下") > -1,
                                  },
                                },
                                [_vm._v("下")]
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                          attrs: { colspan: "2" },
                        },
                        [_vm._v("身长(高)/cm")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                              },
                            },
                            [
                              _c("input", {
                                staticStyle: {
                                  width: "40px",
                                  "border-bottom": "1px solid black",
                                  "border-top": "none",
                                  "border-left": "none",
                                  "border-right": "none",
                                  "margin-bottom": "3px",
                                },
                                domProps: {
                                  value: item.height ? item.height : "",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.heightAssessment &&
                                      item.heightAssessment.indexOf("上") > -1,
                                  },
                                },
                                [_vm._v("上  ")]
                              ),
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.heightAssessment &&
                                      item.heightAssessment.indexOf("中") > -1,
                                  },
                                },
                                [_vm._v("中  ")]
                              ),
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.heightAssessment &&
                                      item.heightAssessment.indexOf("下") > -1,
                                  },
                                },
                                [_vm._v("下")]
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                          attrs: { colspan: "2" },
                        },
                        [_vm._v("体重/身高")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                              },
                            },
                            [
                              _c("input", {
                                staticStyle: {
                                  width: "40px",
                                  "border-bottom": "1px solid black",
                                  "border-top": "none",
                                  "border-left": "none",
                                  "border-right": "none",
                                  "margin-bottom": "3px",
                                },
                                domProps: {
                                  value: item.weightHeight
                                    ? item.weightHeight
                                    : "",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.bmiAssessment &&
                                      item.bmiAssessment.indexOf("上") > -1,
                                  },
                                },
                                [_vm._v("上  ")]
                              ),
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.bmiAssessment &&
                                      item.bmiAssessment.indexOf("中") > -1,
                                  },
                                },
                                [_vm._v("中  ")]
                              ),
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.bmiAssessment &&
                                      item.bmiAssessment.indexOf("下") > -1,
                                  },
                                },
                                [_vm._v("下")]
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                          attrs: { colspan: "2" },
                        },
                        [_vm._v("体格发育评估")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "text-align": "left",
                                "margin-top": "5px",
                                "margin-bottom": "5px",
                                "padding-left": "15px",
                                "border-collapse": "collapse",
                                border: "1px solid black",
                              },
                            },
                            [
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      evaluateContent:
                                        item.physicalDevelopmentAssessment &&
                                        item.physicalDevelopmentAssessment.indexOf(
                                          "正常"
                                        ) > -1,
                                    },
                                  },
                                  [_vm._v("1 正常")]
                                ),
                                _vm._v("    \n              "),
                                _c(
                                  "span",
                                  {
                                    class: {
                                      evaluateContent:
                                        item.physicalDevelopmentAssessment &&
                                        item.physicalDevelopmentAssessment.indexOf(
                                          "低体重"
                                        ) > -1,
                                    },
                                  },
                                  [_vm._v("2 低体重")]
                                ),
                              ]),
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      evaluateContent:
                                        item.physicalDevelopmentAssessment &&
                                        item.physicalDevelopmentAssessment.indexOf(
                                          "消瘦"
                                        ) > -1,
                                    },
                                  },
                                  [_vm._v("3 消瘦")]
                                ),
                                _vm._v("    \n              "),
                                _c(
                                  "span",
                                  {
                                    class: {
                                      evaluateContent:
                                        item.physicalDevelopmentAssessment &&
                                        item.physicalDevelopmentAssessment.indexOf(
                                          "生长迟缓"
                                        ) > -1,
                                    },
                                  },
                                  [_vm._v("4 生长迟缓")]
                                ),
                              ]),
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      evaluateContent:
                                        item.physicalDevelopmentAssessment &&
                                        item.physicalDevelopmentAssessment.indexOf(
                                          "超重"
                                        ) > -1,
                                    },
                                  },
                                  [_vm._v("5 超重")]
                                ),
                                _vm._v("    \n              "),
                                _c(
                                  "span",
                                  {
                                    class: {
                                      evaluateContent:
                                        item.physicalDevelopmentAssessment &&
                                        item.physicalDevelopmentAssessment.indexOf(
                                          "肥胖"
                                        ) > -1,
                                    },
                                  },
                                  [_vm._v("6 肥胖")]
                                ),
                              ]),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _vm._m(0),
                      _vm._m(1),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "font-size": "12px" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        evaluateContent:
                                          item.eyeCare &&
                                          item.eyeCare.indexOf("正常") > -1,
                                      },
                                    },
                                    [_vm._v("1 正常")]
                                  ),
                                  _vm._v("   \n              "),
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        evaluateContent:
                                          item.eyeCare &&
                                          item.eyeCare.indexOf("眼保健") > -1,
                                      },
                                    },
                                    [_vm._v("2 眼保健")]
                                  ),
                                  _vm._v("   \n              "),
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        evaluateContent:
                                          item.eyeCare &&
                                          item.eyeCare.indexOf("异常") > -1,
                                      },
                                    },
                                    [_vm._v("3 异常")]
                                  ),
                                ]
                              ),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    item.rightSphericalMirror
                                      ? item.rightSphericalMirror
                                      : ""
                                  ) +
                                    " / " +
                                    _vm._s(
                                      item.leftSphericalMirror
                                        ? item.leftSphericalMirror
                                        : ""
                                    )
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    item.rightColumnMirror
                                      ? item.rightColumnMirror
                                      : ""
                                  ) +
                                    " / " +
                                    _vm._s(
                                      item.leftColumnMirror
                                        ? item.leftColumnMirror
                                        : ""
                                    )
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    item.rightAxisPosition
                                      ? item.rightAxisPosition
                                      : ""
                                  ) +
                                    " / " +
                                    _vm._s(
                                      item.leftAxisPosition
                                        ? item.leftAxisPosition
                                        : ""
                                    )
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    item.nakedRightEyeVision
                                      ? item.nakedRightEyeVision
                                      : ""
                                  ) +
                                    " / " +
                                    _vm._s(
                                      item.nakedLeftEyeVision
                                        ? item.nakedLeftEyeVision
                                        : ""
                                    )
                                ),
                              ]),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "50px",
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                        },
                        [_vm._v("听 力")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                                "text-align": "left",
                                "padding-left": "15px",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.listening &&
                                      item.listening.indexOf("通过") > -1,
                                  },
                                },
                                [_vm._v("1.通过")]
                              ),
                              _vm._v("  \n            "),
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.listening &&
                                      item.listening.indexOf("不通过") > -1,
                                  },
                                },
                                [_vm._v("2.不通过")]
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "50px",
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                        },
                        [_vm._v("牙数(颗)/龋")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.numberTeeth != null ||
                                      item.numberTeeth == 0
                                      ? item.numberTeeth
                                      : ""
                                  )
                                ),
                              ]),
                              _vm._v("/\n            "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.cariesTotalNumber != null ||
                                      item.cariesTotalNumber == 0
                                      ? item.cariesTotalNumber
                                      : ""
                                  )
                                ),
                              ]),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "50px",
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                        },
                        [_vm._v("胸 部")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                                "text-align": "left",
                                "padding-left": "15px",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.chest && item.chest == "未见异常",
                                  },
                                },
                                [_vm._v("1.未见异常")]
                              ),
                              _vm._v("   \n            "),
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.chest && item.chest == "异常",
                                  },
                                },
                                [_vm._v("2.异常")]
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "50px",
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                        },
                        [_vm._v("腹 部")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                                "text-align": "left",
                                "padding-left": "15px",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.abdomen &&
                                      item.abdomen == "未见异常",
                                  },
                                },
                                [_vm._v("1.未见异常")]
                              ),
                              _vm._v("   \n            "),
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.abdomen && item.abdomen == "异常",
                                  },
                                },
                                [_vm._v("2.异常")]
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "50px",
                            "border-collapse": "collapse",
                            border: "1px solid black",
                            "font-size": "13px",
                          },
                        },
                        [_vm._v("血红蛋白值、肝功能ALT")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                              },
                            },
                            [
                              _c("span", [
                                _c("input", {
                                  staticStyle: {
                                    width: "40px",
                                    "border-bottom": "1px solid black",
                                    "border-top": "none",
                                    "border-left": "none",
                                    "border-right": "none",
                                    "margin-bottom": "3px",
                                  },
                                  domProps: {
                                    value: item.hemoglobinValue
                                      ? item.hemoglobinValue
                                      : "",
                                  },
                                }),
                                _vm._v("g/L    "),
                              ]),
                              _c("span", [
                                _c("input", {
                                  staticStyle: {
                                    width: "40px",
                                    "border-bottom": "1px solid black",
                                    "border-top": "none",
                                    "border-left": "none",
                                    "border-right": "none",
                                    "margin-bottom": "3px",
                                  },
                                  domProps: {
                                    value: item.liverFunction
                                      ? item.liverFunction
                                      : "",
                                  },
                                }),
                                _vm._v("U/L"),
                              ]),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "50px",
                            height: "30px",
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                        },
                        [_vm._v("其他")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    item.otherPhysicalExamination
                                      ? item.otherPhysicalExamination
                                      : ""
                                  )
                                ),
                              ]),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                          attrs: { colspan: "2" },
                        },
                        [_vm._v("发育评估")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                                "text-align": "left",
                                "padding-left": "15px",
                              },
                            },
                            [
                              index === 0
                                ? [
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            (item.developmentaAssessment.indexOf(
                                              "正常"
                                            ) > -1 ||
                                              item.developmentaAssessment.indexOf(
                                                "通过"
                                              ) > -1),
                                        },
                                      },
                                      [_vm._v("1.通过 ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              "不会说自己名字"
                                            ) > -1,
                                        },
                                      },
                                      [_vm._v("2.不会说自己名字 ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              '不会玩"拿棍当马骑"等假想游戏'
                                            ) > -1,
                                        },
                                      },
                                      [
                                        _vm._v("3.不会玩“拿棍当马"),
                                        _c("br"),
                                        _vm._v("骑”等假想游戏  "),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              "不会模仿画圈"
                                            ) > -1,
                                        },
                                      },
                                      [_vm._v("4.不会模仿画圈 ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              "不会双脚跳"
                                            ) > -1,
                                        },
                                      },
                                      [_vm._v("5.不会双脚跳 ")]
                                    ),
                                  ]
                                : _vm._e(),
                              index === 1
                                ? [
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            (item.developmentaAssessment.indexOf(
                                              "正常"
                                            ) > -1 ||
                                              item.developmentaAssessment.indexOf(
                                                "通过"
                                              ) > -1),
                                        },
                                      },
                                      [_vm._v("1.通过 ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              "不会说带形容词的句子"
                                            ) > -1,
                                        },
                                      },
                                      [
                                        _vm._v("2.不会说带形容词的"),
                                        _c("br"),
                                        _vm._v("句子 "),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              "不会按要求等待或轮流"
                                            ) > -1,
                                        },
                                      },
                                      [
                                        _vm._v("3.不会按要求等待或"),
                                        _c("br"),
                                        _vm._v("轮流 "),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              "不会独立穿衣"
                                            ) > -1,
                                        },
                                      },
                                      [_vm._v("4.不会独立穿衣 ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              "不会单脚独立"
                                            ) > -1,
                                        },
                                      },
                                      [_vm._v("5.不会单脚独立 ")]
                                    ),
                                  ]
                                : _vm._e(),
                              index === 2
                                ? [
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            (item.developmentaAssessment.indexOf(
                                              "正常"
                                            ) > -1 ||
                                              item.developmentaAssessment.indexOf(
                                                "通过"
                                              ) > -1),
                                        },
                                      },
                                      [_vm._v("1.通过 ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              "不会简单叙说事情经过"
                                            ) > -1,
                                        },
                                      },
                                      [
                                        _vm._v("2.不会简单叙说事情"),
                                        _c("br"),
                                        _vm._v("经过 "),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              "不知道自己的性别"
                                            ) > -1,
                                        },
                                      },
                                      [_vm._v("3.不知道自己的性别")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              "不会用筷子吃饭"
                                            ) > -1,
                                        },
                                      },
                                      [_vm._v("4.不会用筷子吃饭 ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              "不会单脚跳"
                                            ) > -1,
                                        },
                                      },
                                      [_vm._v("5.不会单脚跳 ")]
                                    ),
                                  ]
                                : _vm._e(),
                              index === 3
                                ? [
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            (item.developmentaAssessment.indexOf(
                                              "正常"
                                            ) > -1 ||
                                              item.developmentaAssessment.indexOf(
                                                "通过"
                                              ) > -1),
                                        },
                                      },
                                      [_vm._v("1.通过 ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              "不会表达自己的感受或想法"
                                            ) > -1,
                                        },
                                      },
                                      [
                                        _vm._v("2.不会表达自己的感"),
                                        _c("br"),
                                        _vm._v("受或想法 "),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              "不会玩角色扮演的集体游戏"
                                            ) > -1,
                                        },
                                      },
                                      [
                                        _vm._v("3.不会玩角色扮演的"),
                                        _c("br"),
                                        _vm._v("集体游戏 "),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              "会画方形"
                                            ) > -1,
                                        },
                                      },
                                      [_vm._v("4.会画方形 ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          evaluateContent:
                                            item.developmentaAssessment &&
                                            item.developmentaAssessment.indexOf(
                                              "不会奔跑"
                                            ) > -1,
                                        },
                                      },
                                      [_vm._v("5.不会奔跑 ")]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                          attrs: { colspan: "2" },
                        },
                        [_vm._v("两次随访间患病情况")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                                "text-align": "left",
                                "padding-left": "15px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: {
                                    evaluateContent:
                                      item.twoFollowSufferingIllness &&
                                      item.twoFollowSufferingIllness.indexOf(
                                        "无"
                                      ) > -1,
                                  },
                                },
                                [_vm._v("1.无")]
                              ),
                              _c(
                                "div",
                                {
                                  class: {
                                    evaluateContent:
                                      item.twoFollowSufferingIllness &&
                                      item.twoFollowSufferingIllness.indexOf(
                                        "肺炎"
                                      ) > -1,
                                  },
                                },
                                [
                                  _vm._v("2.肺炎"),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        "text-align": "center",
                                        "min-width": "40px",
                                        "border-bottom": "1px solid black",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.pneumonia != null &&
                                            item.pneumonia != undefined
                                            ? item.pneumonia
                                            : ""
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v("次"),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  class: {
                                    evaluateContent:
                                      item.twoFollowSufferingIllness &&
                                      item.twoFollowSufferingIllness.indexOf(
                                        "腹泻"
                                      ) > -1,
                                  },
                                },
                                [
                                  _vm._v("3.腹泻"),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        "text-align": "center",
                                        "min-width": "40px",
                                        "border-bottom": "1px solid black",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.diarrhea != null &&
                                            item.diarrhea != undefined
                                            ? item.diarrhea
                                            : ""
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v("次"),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  class: {
                                    evaluateContent:
                                      item.twoFollowSufferingIllness &&
                                      item.twoFollowSufferingIllness.indexOf(
                                        "外伤"
                                      ) > -1,
                                  },
                                },
                                [
                                  _vm._v("4.外伤"),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        "text-align": "center",
                                        "min-width": "40px",
                                        "border-bottom": "1px solid black",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.trauma != null &&
                                            item.trauma != undefined
                                            ? item.trauma
                                            : ""
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v("次"),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  class: {
                                    evaluateContent:
                                      item.twoFollowSufferingIllness &&
                                      item.twoFollowSufferingIllness.indexOf(
                                        "其他"
                                      ) > -1,
                                  },
                                },
                                [_vm._v("5.其他")]
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                          attrs: { colspan: "2" },
                        },
                        [_vm._v("两次随访间意外伤害")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                                "text-align": "left",
                                "padding-left": "15px",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.accidentalInjury &&
                                      item.accidentalInjury.indexOf("无") > -1,
                                  },
                                },
                                [_vm._v("1.无")]
                              ),
                              _vm._v("   \n            "),
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.accidentalInjury &&
                                      item.accidentalInjury.indexOf("有") > -1,
                                  },
                                },
                                [_vm._v("2.有")]
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    { staticStyle: { "line-height": "25px" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                          attrs: { colspan: "2" },
                        },
                        [_vm._v("高危儿")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                                "text-align": "left",
                                "padding-left": "15px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: {
                                    evaluateContent:
                                      item.highRiskChildren &&
                                      item.highRiskChildren.indexOf("否") > -1,
                                  },
                                },
                                [_vm._v("1.否")]
                              ),
                              _c(
                                "div",
                                {
                                  class: {
                                    evaluateContent:
                                      item.highRiskChildren &&
                                      item.highRiskChildren.indexOf("是") > -1,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              2.是(管理：\n              "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        evaluateContent:
                                          item.highRiskChildrenManagement &&
                                          item.highRiskChildrenManagement.indexOf(
                                            "无"
                                          ) > -1,
                                      },
                                    },
                                    [_vm._v("1.无")]
                                  ),
                                  _vm._v("，\n              "),
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        evaluateContent:
                                          item.highRiskChildrenManagement &&
                                          item.highRiskChildrenManagement.indexOf(
                                            "有"
                                          ) > -1,
                                      },
                                    },
                                    [_vm._v("2.有")]
                                  ),
                                  _vm._v("\n              )\n            "),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                          attrs: { colspan: "2" },
                        },
                        [_vm._v("转诊建议")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                                "text-align": "left",
                                "padding-left": "15px",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.referralSuggestion &&
                                      (item.referralSuggestion == 1 ||
                                        item.referralSuggestion
                                          .toString()
                                          .indexOf("无") > -1),
                                  },
                                },
                                [_vm._v("1.无")]
                              ),
                              _vm._v("   \n            "),
                              _c(
                                "span",
                                {
                                  class: {
                                    evaluateContent:
                                      item.referralSuggestion &&
                                      (item.referralSuggestion == 2 ||
                                        item.referralSuggestion
                                          .toString()
                                          .indexOf("有") > -1),
                                  },
                                },
                                [_vm._v("2.有")]
                              ),
                              _c("div", [
                                _vm._v("原因:"),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "text-align": "left",
                                      "margin-bottom": "-3px",
                                      "min-width": "100px",
                                      "border-bottom": "1px solid black",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.reasonReferral
                                          ? item.reasonReferral
                                          : ""
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", [
                                _vm._v("机构及科室:\n              "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "text-align": "left",
                                      "margin-bottom": "3px",
                                      "min-width": "130px",
                                      "border-bottom": "1px solid black",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          (item.reasonInstitution
                                            ? item.reasonInstitution + ";"
                                            : "") +
                                            (item.reasonDepartment
                                              ? item.reasonDepartment
                                              : "")
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                          attrs: { colspan: "2" },
                        },
                        [_vm._v("指导")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "text-align": "left",
                                "padding-left": "15px",
                                "border-collapse": "collapse",
                                border: "1px solid black",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: {
                                    evaluateContent:
                                      item.guidance &&
                                      item.guidance.indexOf("合理膳食") > -1,
                                  },
                                },
                                [_vm._v("1.合理膳食")]
                              ),
                              _c(
                                "div",
                                {
                                  class: {
                                    evaluateContent:
                                      item.guidance &&
                                      item.guidance.indexOf("生长发育") > -1,
                                  },
                                },
                                [_vm._v("2.生长发育")]
                              ),
                              _c(
                                "div",
                                {
                                  class: {
                                    evaluateContent:
                                      item.guidance &&
                                      item.guidance.indexOf("疾病预防") > -1,
                                  },
                                },
                                [_vm._v("3.疾病预防")]
                              ),
                              _c(
                                "div",
                                {
                                  class: {
                                    evaluateContent:
                                      item.guidance &&
                                      item.guidance.indexOf("预防伤害") > -1,
                                  },
                                },
                                [_vm._v("4.预防伤害")]
                              ),
                              _c(
                                "div",
                                {
                                  class: {
                                    evaluateContent:
                                      item.guidance &&
                                      item.guidance.indexOf("口腔保健") > -1,
                                  },
                                },
                                [_vm._v("5.口腔保健")]
                              ),
                              _c(
                                "div",
                                {
                                  class: {
                                    evaluateContent:
                                      item.guidance &&
                                      item.guidance.indexOf("其他") > -1,
                                  },
                                },
                                [
                                  _vm._v("6.其他 "),
                                  _c("input", {
                                    staticStyle: {
                                      width: "80px",
                                      "border-bottom": "1px solid black",
                                      "border-top": "none",
                                      "border-left": "none",
                                      "border-right": "none",
                                      "margin-bottom": "3px",
                                    },
                                    domProps: {
                                      value: item.otherContent
                                        ? item.otherContent
                                        : "",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                          attrs: { colspan: "2" },
                        },
                        [_vm._v("下次随访日期")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                                "text-align": "center",
                              },
                            },
                            [_vm._v(_vm._s(item.nextFollowDate))]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "border-collapse": "collapse",
                            border: "1px solid black",
                          },
                          attrs: { colspan: "2" },
                        },
                        [_vm._v("随访医生签名")]
                      ),
                      _vm._l(
                        _vm.model.ageChildren.recored &&
                          _vm.model.ageChildren.recored.length > 0
                          ? _vm.model.ageChildren.recored
                          : _vm.monthAges,
                        function (item, index) {
                          return _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "1px solid black",
                                "text-align": "center",
                              },
                            },
                            [
                              item.followUpDoctorSignature
                                ? _c("img", {
                                    staticStyle: {
                                      height: "40px",
                                      "object-fit": "contain",
                                    },
                                    attrs: {
                                      src: item.followUpDoctorSignature,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  ),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          width: "20px",
          "border-collapse": "collapse",
          border: "1px solid black",
          "writing-mode": "vertical-rl",
          "text-orientation": "upright",
          "letter-spacing": "15px",
        },
        attrs: { rowspan: "7" },
      },
      [_c("span", [_vm._v("体格评价")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          width: "50px",
          "border-collapse": "collapse",
          border: "1px solid black",
        },
      },
      [
        _c("div", [_vm._v("S")]),
        _c("div", [_vm._v("C")]),
        _c("div", [_vm._v("A")]),
        _c("div", [
          _vm._v("视力"),
          _c("span", { staticStyle: { "font-size": "12px" } }, [
            _vm._v("(右/左)"),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }